import React, { PropsWithChildren, ReactNode, useState } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import type { XHComponentCommonProps } from "../../types";

import "./index.scss";

type OptionType =
  | {
      label?: string;
      value?: string;
      disabled?: boolean;
      [key: string]: any;
    }
  | string;

interface CheckboxProps<T>
  extends PropsWithChildren<{}>,
    XHComponentCommonProps {
  option: T[];
  fill?: boolean;
  label?: ReactNode;
  onChange: (item: T) => void;
  defaultValue?: T;
  style?: React.CSSProperties;
  border?: boolean;
  /**
   * paddingHorizontal 横向间距
   */
  paddingHorizontal?: boolean;
  dataTrackId?: string;
}

const CheckboxButton = <T extends OptionType = string>(
  props: CheckboxProps<T>
) => {
  const {
    option,
    onChange,
    defaultValue = "",
    label,
    fill = false,
    className,
    style,
    border = true,
    paddingHorizontal = true,
    dataTrackId,
  } = props;
  const [selectedValue, setSelectedValue] = useState(
    typeof defaultValue === "string" ? defaultValue : defaultValue.value
  );

  const clickHandle = (item: T) => {
    setSelectedValue(typeof item === "string" ? item : item.value);
    onChange(item);
  };

  return (
    <View
      // @ts-ignore
      dataTrackId={dataTrackId}
      className={classNames("xh-checkbox-button", className, {
        border,
        paddingHorizontal,
      })}
      style={style}
    >
      {label && <View className="xh-checkbox-button-label">{label}</View>}
      <View className="xh-checkbox-button-options">
        {option.map((item, index) => {
          return (
            <View
              key={index}
              // @ts-ignore
              dataTrackId={dataTrackId + "-" + index}
              className={classNames("xh-checkbox-button-options-item", {
                active:
                  typeof item === "string"
                    ? item === selectedValue
                    : item.value === selectedValue,
                fill,
              })}
              onClick={() => {
                clickHandle(item);
              }}
            >
              <p className="xh-checkbox-button-options-item-label">
                {typeof item === "string" ? item : item.label}
              </p>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default CheckboxButton;
